import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { alert } from 'actions/flash'
import { useUpdateMerchantMutation } from 'api/merchants'
import { isError } from 'api/utils'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import { setFormSubmitting } from 'slices/Cms/Settings/PostOrderFeedback'
import {
  selectApiFormattedFormData,
  selectFormDisabled,
  selectIsFormSubmitting,
} from 'slices/Cms/Settings/PostOrderFeedback/selectors'

const t = buildTranslate('cms.settings.post_order_feedback')

export const usePostOrderFeedbackSubmitForm = () => {
  const dispatch = useDispatch()
  const apiFormattedFormData = useSelector(selectApiFormattedFormData)
  const formDisabled = useSelector(selectFormDisabled)
  const isFormSubmitting = useSelector(selectIsFormSubmitting)
  const [updateMerchant] = useUpdateMerchantMutation()

  const handleSubmit = useCallback(async () => {
    if (formDisabled || isFormSubmitting) return

    dispatch(setFormSubmitting(true))
    try {
      const result = await updateMerchant({
        data: apiFormattedFormData,
      })

      if (isError(result)) {
        dispatch(
          alert({
            key: 'danger',
            message: t('alert.submit_error'),
            timeout: 5,
          })
        )
        return
      }

      dispatch(
        alert({
          key: 'success',
          message: t('alert.submit_success'),
          timeout: 5,
        })
      )
    } finally {
      // Always clear isFormSubmitting — covers the normal isError path AND
      // a thrown error from any middleware in the dispatch chain (interceptor
      // re-rejecting, future middleware wrapping). Without this the form stays
      // permanently disabled on a thrown rejection.
      dispatch(setFormSubmitting(false))
    }
  }, [
    apiFormattedFormData,
    updateMerchant,
    dispatch,
    formDisabled,
    isFormSubmitting,
  ])

  return handleSubmit
}
